/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { VerificationSwagger } from 'src/clu/core/services/trainedModels/cluModelVerificationSwagger';
import { ProgressTrackerStore } from 'src/core/stores/ProgressTrackerStore';
import { OmitFunctions } from 'src/core/stores/types';
import { ModelEvaluationStore } from 'src/modules/modelDetails/stores/ModelEvaluationStore';
import { ModelGuidanceStore } from 'src/modules/modelGuidance/stores/ModelGuidanceStore';

export class CluTrainedModelStore {
    public id: string;

    public name: string;

    public lastTrainingDate: Date;

    public lastTrainingDuration: number;

    public expirationDate: Date;

    public trainingConfigVersion: string;

    public hasSnapshot: boolean;

    constructor(name: string, data?: Partial<OmitFunctions<Omit<CluTrainedModelStore, 'name'>>>) {
        this.name = name;
        this.id = data?.id || name;
        this.lastTrainingDate = data?.lastTrainingDate;
        this.lastTrainingDuration = data?.lastTrainingDuration;
        this.expirationDate = data?.expirationDate;
        this.trainingConfigVersion = data?.trainingConfigVersion;
        this.hasSnapshot = data?.hasSnapshot;
    }

    @observable public intentEvaluationStore: ModelEvaluationStore;

    @observable public entityEvaluationStore: ModelEvaluationStore;

    @observable public intentModelGuidanceStore: ModelGuidanceStore;

    @observable public entityModelGuidanceStore: ModelGuidanceStore;

    @observable public modelVerificationData: VerificationSwagger[];

    public readonly evaluationTracker = new ProgressTrackerStore();

    public readonly modelGuidanceTracker = new ProgressTrackerStore();

    @action
    public setIntentEvaluationStore(store: ModelEvaluationStore) {
        this.intentEvaluationStore = store;
    }

    @action
    public setEntityEvaluationStore(store: ModelEvaluationStore) {
        this.entityEvaluationStore = store;
    }

    @action
    public setModelVerificationData(data: VerificationSwagger[]) {
        this.modelVerificationData = data;
    }

    @action
    public setIntentModelGuidanceStore(store: ModelGuidanceStore) {
        this.intentModelGuidanceStore = store;
    }

    @action
    public setEntityModelGuidanceStore(store: ModelGuidanceStore) {
        this.entityModelGuidanceStore = store;
    }
}
